import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  FormControl,
  Container,
  Grid,
  Box,
  Stack,
  OutlinedInput,
  InputLabel,
  MenuItem,
  ListItemText,
  Select,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Modal,
  Typography,
  Paper,
} from "@mui/material";
// import "./test.css";

import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
// import { bookApoinment } from "./asppoinmentApi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
// import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import CalendarComponent from "./calenderPop";

import { Assignment, Label } from "@mui/icons-material";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { setbusinessChooseTab } from "../../app/store/reducer";
import { ModalHeader } from "../../common/modalHeader";

// import { getAlldetailSerice } from "../services/servicesListApi";
// import { getAllEmployeeList } from "../features/employeeInfo/appoinmentDashboardApi";

dayjs.extend(utc);
dayjs.extend(timezone);

const CalenderModal = ({
  data,
  open,
  setValuet,
  setOpen,
  callback,
  initialFormattedDate,
  setinitialFormattedDate,
}) => {
  const [count, setCount] = useState({
    totalAppoinments: 0,
  });
  const dispatch = useDispatch();
  useEffect(() => {
    if (open && initialFormattedDate) {
      let datat = [...data];
      let obj = {
        Completed: 0,

        Cancelled: 0,
        Unassigned: 0,
        Assigned: 0,
      };
      datat.forEach((ele, index) => {
        console.log("objobj", ele);

        obj[ele.status] += 1;
      });

      console.log("objobj ", obj);
      setCount({ ...count, ...obj, totalAppoinments: data.length });
    } else {
      setCount({ totalAppoinments: 0 });
    }
  }, [open, data]);

  return (
    // <Modal
    //   open={open}
    //   onClose={() => {
    //     // setFormData({...struct})
    //     setOpen(false);
    //   }}
    //   aria-labelledby="modal-modal-title"
    //   aria-describedby="modal-modal-description"
    // >
    //   <Box
    //     sx={{
    //       background: "white",

    //       width: "52%",
    //       overflowY: "auto",
    //       zIndex: "99999",
    //       // height: "90vh",
    //       position: "absolute",
    //       left: "25%",
    //       top: "10%",
    //     }}
    //   >
    //     <Container>
    //       <ModalHeader
    //         onClose={() => {
    //           setOpen(false);
    //         }}
    //         title={"Appoinment Calender"}
    //       />

    //       <Grid container>
    //         <Grid
    //           item
    //           xs={12}
    //           sx={{
    //             overflowY: "auto",
    //             maxHeight: {
    //               xs: "calc(100vh - 60px)",
    //               sm: "calc(100vh - 60px)",
    //             },
    //           }}
    //         >
    //           <CalendarComponent
    //             initialFormattedDate={initialFormattedDate}
    //             setinitialFormattedDate={setinitialFormattedDate}
    //           />
    //         </Grid>

    //         <Grid item xs={6}>
    //           <Typography> Total Appoinnments</Typography>
    //         </Grid>
    //         <Grid item xs={4}>
    //           <Typography>
    //             {" "}
    //             {count.totalAppoinments
    //               ? count.totalAppoinments
    //               : "Not Available"}
    //           </Typography>
    //         </Grid>
    //         <Grid item xs={2}>
    //           {/* <Typography> {count.totalAppoinments}</Typography> */}
    //         </Grid>
    //         <Grid item xs={6}>
    //           <Typography> Assigned Appoitment</Typography>
    //         </Grid>
    //         <Grid item xs={4}>
    //           <Typography>
    //             {" "}
    //             {count?.Assigned ? count?.Assigned : "Not Available"}
    //           </Typography>
    //         </Grid>
    //         <Grid item xs={2}>
    //           <ArrowForwardIcon
    //             sx={{ cursor: "pointer" }}
    //             onClick={() => {
    //               dispatch(
    //                 setbusinessChooseTab({
    //                   value: "Assigned",
    //                   label: "Assigned",
    //                 })
    //               );
    //               setOpen(false);
    //               setValuet("Assigned");
    //             }}
    //           />
    //           {/* <Typography> {count.totalAppoinments}</Typography> */}
    //         </Grid>

    //         <Grid item xs={6}>
    //           <Typography> Unassigned Appoitments</Typography>
    //         </Grid>
    //         <Grid item xs={4}>
    //           <Typography>
    //             {" "}
    //             {count?.Unassigned ? count?.Unassigned : "Not Available"}
    //           </Typography>
    //         </Grid>
    //         <Grid item xs={2}>
    //           <ArrowForwardIcon
    //             sx={{ cursor: "pointer" }}
    //             onClick={() => {
    //               dispatch(
    //                 setbusinessChooseTab({
    //                   value: "Unassigned",
    //                   label: "Unassigned",
    //                 })
    //               );
    //               setOpen(false);
    //               setValuet("Unassigned");
    //             }}
    //           />
    //           {/* <Typography> {count.totalAppoinments}</Typography> */}
    //         </Grid>

    //         <Grid item xs={6}>
    //           <Typography> Cancelled Appoitments</Typography>
    //         </Grid>
    //         <Grid item xs={4}>
    //           <Typography> {count?.Cancelled}</Typography>
    //         </Grid>
    //         <Grid item xs={2}>
    //           <ArrowForwardIcon
    //             sx={{ cursor: "pointer" }}
    //             onClick={() => {
    //               dispatch(
    //                 setbusinessChooseTab({
    //                   value: "Assigned",
    //                   label: "Assigned",
    //                 })
    //               );
    //               setOpen(false);
    //               setValuet("Cancelled");
    //             }}
    //           />
    //           {/* <Typography> {count.totalAppoinments}</Typography> */}
    //         </Grid>

    //         <Grid item xs={6}>
    //           <Typography> Completed Appoitments</Typography>
    //         </Grid>
    //         <Grid item xs={4}>
    //           <Typography>
    //             {" "}
    //             {count?.Completed ? count?.Completed : "Not Available"}
    //           </Typography>
    //         </Grid>
    //         <Grid item xs={2}>
    //           <ArrowForwardIcon
    //             sx={{ cursor: "pointer" }}
    //             onClick={() => {
    //               dispatch(
    //                 setbusinessChooseTab({
    //                   value: "Assigned",
    //                   label: "Assigned",
    //                 })
    //               );
    //               setOpen(false);
    //               setValuet("Completed");
    //             }}
    //           />
    //           {/* <Typography> {count.totalAppoinments}</Typography> */}
    //         </Grid>
    //       </Grid>
    //     </Container>{" "}
    //   </Box>
    // </Modal>

    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          width: { xs: "90%", sm: "70%", md: "52%" },
          overflowY: "auto",
          zIndex: "99999",
          position: "absolute",
          left: "50%",
          top: "10%",
          transform: "translateX(-50%)",
          borderRadius: "12px",
          boxShadow: 3,
          maxHeight: "85vh",
          p: 3,
        }}
      >
        <Container>
          <ModalHeader
            onClose={() => setOpen(false)}
            title={"Appointment Calendar"}
          />

          <Grid container spacing={2}>
            <Grid item xs={12} sx={{ overflowY: "auto", maxHeight: "calc(100vh - 200px)" }}>
              <CalendarComponent
                initialFormattedDate={initialFormattedDate}
                setinitialFormattedDate={setinitialFormattedDate}
              />
            </Grid>

            {[
              { label: "Total Appointments", key: "totalAppoinments" },
              { label: "Assigned Appointments", key: "Assigned" },
              { label: "Unassigned Appointments", key: "Unassigned" },
              { label: "Cancelled Appointments", key: "Cancelled" },
              { label: "Completed Appointments", key: "Completed" },
            ].map((item, index) => (
              <Grid item xs={12} key={index}>
                <Paper sx={{ p: 2, display: "flex", alignItems: "center", justifyContent: "space-between", borderRadius: "8px", boxShadow: 2 }}>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    {item.label}
                  </Typography>
                  <Typography variant="body2">
                    {count?.[item.key] ? count[item.key] : "Not Available"}
                  </Typography>
                  {item.key !== "totalAppoinments" && (
                    <ArrowForwardIcon
                      sx={{ cursor: "pointer", color: "primary.main" }}
                      onClick={() => {
                        dispatch(setbusinessChooseTab({ value: item.key, label: item.key }));
                        setOpen(false);
                        setValuet(item.key);
                      }}
                    />
                  )}
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </Modal>
  );
};

export default CalenderModal;
